import React from 'react';
import { motion } from 'framer-motion';
import '../../styles/globals.css';

const PriceTag = ({ price, currency = 'inr', originalPrice, discount, size = 'medium', showCurrency = true }) => {
    const formatPrice = (amount) => {
        return new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: currency,
            minimumFractionDigits: 0,
            maximumFractionDigits: 2
        }).format(amount);
    };

    const sizes = {
        small: {
            fontSize: '0.875rem',
            gap: '0.25rem'
        },
        medium: {
            fontSize: '1.125rem',
            gap: '0.5rem'
        },
        large: {
            fontSize: '1.5rem',
            gap: '0.75rem'
        }
    };

    const currentSize = sizes[size];

    return (
        <motion.div
            className="price-tag"
            initial={{ opacity: 0, scale: 0.95 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.4 }}
            style={{
                display: 'flex',
                alignItems: 'baseline',
                gap: currentSize.gap,
                fontFamily: 'var(--font-body)'
            }}
        >
            {originalPrice && (
                <motion.span
                    className="original-price"
                    initial={{ opacity: 1 }}
                    animate={{ opacity: 0.6 }}
                    style={{
                        fontSize: `calc(${currentSize.fontSize} * 0.8)`,
                        textDecoration: 'line-through',
                        color: 'var(--charcoal-60)'
                    }}
                >
                    {formatPrice(originalPrice)}
                </motion.span>
            )}

            <motion.span
                className="current-price"
                style={{
                    fontSize: currentSize.fontSize,
                    fontWeight: 600,
                    color: 'var(--deep-charcoal)'
                }}
            >
                {showCurrency ? formatPrice(price) : `$${price}`}
            </motion.span>

            {discount && (
                <motion.span
                    className="discount-badge"
                    initial={{ scale: 0 }}
                    animate={{ scale: 1 }}
                    transition={{ type: 'spring', stiffness: 200 }}
                    style={{
                        fontSize: `calc(${currentSize.fontSize} * 0.7)`,
                        backgroundColor: 'var(--muted-sage)',
                        color: 'white',
                        padding: '0.125rem 0.5rem',
                        borderRadius: 'var(--border-radius-sm)',
                        fontWeight: 500
                    }}
                >
                    -{discount}%
                </motion.span>
            )}
        </motion.div>
    );
};

export default PriceTag;